import { render, staticRenderFns } from "./JobInformation.vue?vue&type=template&id=0d0965bf&"
import script from "./JobInformation.vue?vue&type=script&lang=js&"
export * from "./JobInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports